export const RECEIVE_SOURCES = 'RECEIVE_SOURCES'

export const receiveSources = (data) => ({ type: RECEIVE_SOURCES, data })
